import React from "react";
import { Paper, makeStyles } from "@material-ui/core";
import locale from "@bonliva-crm/locale";
import { Body } from "@components";
import SaveIcon from "@material-ui/icons/Autorenew";
import SavedIcon from "@material-ui/icons/Done";

type Props = {
  saving: boolean;
  saved: boolean;
  error: boolean;
};

export function AutoSaveIndicator(props: Props) {
  const classes = useStyles({});

  let content;

  if (props.error) {
    content = (
      <>
        <SaveIcon color="action" className="spin-forever" />
        <Body>{locale.ErrorOccurred}</Body>
      </>
    );
  } else {
    if (props.saving) {
      content = (
        <>
          <SaveIcon color="primary" className="spin-forever" />
          <Body>{locale.Unsaved}</Body>
        </>
      );
    } else if (props.saved) {
      content = (
        <>
          <SavedIcon color="secondary" />
          <Body>{locale.Saved}</Body>
        </>
      );
    }
  }

  if (!content) {
    return null; // this should not happen really
  }

  return <Paper className={classes.root}>{content}</Paper>;
}

const useStyles = makeStyles(() => ({
  root: {
    padding: 8,
    display: "flex",
    alignItems: "center",
    "& > *": {
      marginLeft: 8
    }
  }
}));
